export class NetworkInterfaceConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mode",
            "baseName": "mode",
            "type": "NetworkInterfaceConfigModeEnum",
            "format": ""
        },
        {
            "name": "nicId",
            "baseName": "nicId",
            "type": "string",
            "format": ""
        },
        {
            "name": "nicName",
            "baseName": "nicName",
            "type": "string",
            "format": ""
        },
        {
            "name": "vnet",
            "baseName": "vnet",
            "type": "VNetConfig",
            "format": ""
        },
        {
            "name": "subnet",
            "baseName": "subnet",
            "type": "SubnetConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NetworkInterfaceConfig.attributeTypeMap;
    }
    constructor() {
    }
}
export var NetworkInterfaceConfigModeEnum;
(function (NetworkInterfaceConfigModeEnum) {
    NetworkInterfaceConfigModeEnum["Existing"] = "existing";
    NetworkInterfaceConfigModeEnum["Create"] = "create";
})(NetworkInterfaceConfigModeEnum || (NetworkInterfaceConfigModeEnum = {}));
